import React, { Component } from "react";
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import ReactFC from "react-fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import $ from "jquery";

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

class BarsGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data = [], caption, xAxisName } = this.props;
    const chartConfigs = {
      type: "column2d",
      width: "98%",
      height: 400,
      dataFormat: "json",
      dataSource: {
        chart: { caption, xAxisName, theme: "fusion" },
        data,
      },
    };
    return <ReactFC {...chartConfigs} />;
  }
}
export { BarsGraph as default };
